export default __webpack_public_path__ + "static/media/018-Shih Tzu.2cd5db0d.svg";